import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ChevronLeft } from '@mui/icons-material';
import { Button, Typography } from '@mui/material';
import { useStyles } from './styles.js';
import { navigateBack } from '@/utils';

const TabPanelBackLink = ({ to, edit = '', text = 'Back', useFromState = true }) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = () => {
    const from = useFromState ? location.state?.from : undefined;
    const fallbackTo = from?.pathname ? `${from.pathname}${from.search || ''}` : to;

    navigateBack(navigate, fallbackTo);
  };

  return (
    <Button className={classes.back} onClick={handleClick}>
      <ChevronLeft />
      {edit || text ? (
        <Typography className={classes.backText}>
          {edit && (
            <>
              {edit}
              <br />
            </>
          )}
          <span>{text}</span>
        </Typography>
      ) : null}
    </Button>
  );
};

export default TabPanelBackLink;
